import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { getBackDestination } from '@/utils/routing';

import ChevronLeft from '../../../assets/icon-chevron-left.svg?react';

interface Props extends React.HTMLAttributes<HTMLElement> {
    desktop?: boolean;
    className?: string;
}

function BackLink(props: Props) {
    const windowLocation = useLocation();
    const navigate = useNavigate();

    const goBack = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();

        navigate(getBackDestination(windowLocation.pathname));
    };

    const linkProps = {
        className: `text-dark ${props?.className || ''} ${getBackDestination(windowLocation.pathname) ? '' : 'invisible'
            }`,
    };

    const element = (
        <div className='flex align-center d-lg-none'>
            <a href={'#'} {...linkProps} style={{ lineHeight: 1 }} onClick={goBack}>
                <ChevronLeft />
            </a>
        </div>
    );

    return element;
}

export default BackLink;
